module.exports = "<div *ngIf=\"show\" class=\"status_confirm\">\n    <div class=\"row status_confirm_wraper\">\n        <p  translate [translateParams]=\"confirmationMessage.context\">{{ confirmationMessage.text }}</p>\n        <div class=\"save_status\"><button (click) = \"agree()\" class=\"{{'b_btn' | panelClass}}\" translate>AGREE</button></div>\n        <div class=\"cancel_status\"><button (click) = \"cancel()\" class=\"{{'b_btn' | panelClass}}\" translate>CANCEL</button></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/modal-dialog/modal-window.html
// module id = 1055
// module chunks = 3